import canUseDom from '@clearscore/helpers.can-use-dom';
import getEnv from '@clearscore/helpers.envs';
import UAParser from 'ua-parser-js';

const browserParsed = new UAParser().getResult();
const SERVER = 'server';
const NATIVE = 'native';
const MOBILE = 'mobile';
const WEBVIEW = 'WEBVIEW';

function trackingDevice() {
    if (!canUseDom()) {
        return SERVER;
    }

    const deviceLib = require('current-device');
    const device = deviceLib.default || deviceLib;

    const isWebview = getEnv(WEBVIEW);
    const type = isWebview ? NATIVE : device.type;

    if (type === MOBILE) {
        return device.os;
    }
    return `${type}_${device.os}`;
}

trackingDevice.DEVICE_NAME = `${browserParsed.os.name} ${browserParsed.browser.name}`;

export default trackingDevice;
